import React, { useState } from 'react'; // Add useState import
import styles from './RealEstate.module.css';
import backgroundImage from '../../Images/bgT81.png'; // Import from images folder
import Thealth2 from '../../Images/T6.png';
import icon12 from '../../Images/icon12.png';
import icon15 from '../../Images/icon15.png';
import icon16 from '../../Images/icon16.png';

import iconT44 from '../../Images/iconT52.png'; 
import iconT45 from '../../Images/icoT87.png'; 
import iconT46 from '../../Images/icoT89.png'; 
import iconT47 from '../../Images/icon48.png'; 
import iconT48 from '../../Images/icon50.png'; 

import Icon71 from '../../Images/icon81.png';
import icon72 from '../../Images/icon82.png';
import icon73 from '../../Images/icon87.png';
import icon74 from '../../Images/icon88.png';
import icon75 from '../../Images/icon89.png';
import icon76 from '../../Images/icon90.png';

import Ibg71 from '../../Images/Ibg71.png';


import iconT76 from '../../Images/iconT71.png';
import iconT77 from '../../Images/iconT72.png';
import iconT78 from '../../Images/iconT73.png';


import T56 from '../../Images/T68.png'; 
import T57 from '../../Images/T69.png';
import T58 from '../../Images/T70.png';
import T59 from '../../Images/T71.png';

import T66 from '../../Images/T76.png';
import T67 from '../../Images/T67.png';

import iconT49 from '../../Images/icon77.png'; 

import icon1 from '../../Images/icon80.png';
import icon2 from '../../Images/icoT80.png';
import icon3 from '../../Images/icoT81.png';

import icon4 from '../../Images/iconchatT71.png';
import icon5 from '../../Images/iconchatT72.png';
import icon6 from '../../Images/iconchatT73.png';

import bgT56 from '../../Images/T87.png';

import bT1 from '../../Images/I73.png';
import bT2 from '../../Images/I74.png';
import bT3 from '../../Images/I75.png';

// import bg1 from '../../Images/bg1.png';
// import cd1 from '../../Images/cd1.png';
// import cd2 from '../../Images/cd2.png';
// import cd3 from '../../Images/cd3.png';
// import cd4 from '../../Images/cd4.png';
// import sicon1 from '../../Images/sicon1.png';


const RealEstate = () => {
  const handleCTAClick = (action) => {
    console.log(`${action} clicked`);
    // Add your navigation/modal logic here
  };

  // FAQ Section State and Data
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqs = [
    {
      question: "How quickly can I get started with ToxBox AI?",
      answer: "You can be up and running in less than 24 hours. Our team will help you integrate ToxBox AI with your website and CRM, upload your property listings, and customize the AI responses to match your brand voice."
    },
    {
      question: "Does ToxBox AI work with my existing CRM?",
      answer: "Yes! ToxBox AI seamlessly integrates with all major real estate CRMs including Salesforce, HubSpot, Follow Up Boss, kvCORE, and more. All leads and conversations are automatically synced to your CRM in real-time."
    },
    {
      question: "Can the AI handle complex real estate questions?",
      answer: "Absolutely. Our AI is trained on millions of real estate conversations and can handle questions about property details, neighborhoods, pricing, financing, and more. For complex questions it can't answer, it smoothly transitions to a human agent."
    },
    {
      question: "How much does ToxBox AI cost?",
      answer: "We offer flexible pricing plans starting at $299/month for individual agents, with team and brokerage plans available. All plans include unlimited conversations, CRM integration, and 24/7 support. Contact us for a custom quote."
    },
    {
      question: "What if a prospect wants to talk to a real person?",
      answer: "ToxBox AI can instantly connect prospects with your team via phone, text, or video call. You can also set business hours when the AI should route conversations directly to agents, and when it should handle inquiries independently."
    }
  ];

  return (
     <div className={styles.container80}>
  {/* Hero Section */}
  <section className={styles.heroSection80}>
    <div className={styles.heroContent80}>
      {/* Top label */}
      <div className={styles.heroLabel80}>
        <span className={styles.labelText80}>♻ AI-Powered Real Estate Solutions</span>
      </div>

      {/* Main headline */}
      <h1 className={styles.heroHeadline80}>
       Turn every property lead<br /> into a real conversation
      </h1>

      {/* Subtext */}
      <p className={styles.heroSubtext80}>
        Engage prospects instantly, qualify leads
        automatically, and<br /> convert more opportunities with AI-powered conversations<br /> that never sleep.
      </p> 

      {/* CTA Buttons */}
      <div className={styles.ctaButtons80}>
        <button
          className={`${styles.ctaButton80} ${styles.ctaPrimary80}`}
          onClick={() => handleCTAClick('Request a Demo')}
        >
          Get Started →
        </button>
        <button
          className={`${styles.ctaButton80} ${styles.ctaSecondary80}`}
          onClick={() => handleCTAClick('Learn More')}
        >
          ▷ Watch Overview
        </button>
      </div>

      
    </div>

    {/* Background Image Container */}
    <div className={styles.heroBackground80}>
      <div
        className={styles.backgroundImage80}
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      />
    </div>
  </section>



















{/* Why ToxBox AI Matters 81 */}
<section className={styles.RealEstate81}>
  <div className={styles.container81}>
    {/* Header Section */}
    <div className={styles.header81}>
      <h1 className={styles.title81}>Why ToxBox AI Matters</h1>
      <p className={styles.subtitle81}>
        Most real estate buyers engage first online, track down Squareft, and can spend days researching before reaching out. With ToxBox, ensure that self-reliant, automated responses are ready to convert.
      </p>
    </div>

    <div className={styles.content81}>
      {/* Left Side - Image */}
      <div className={styles.leftSection81}>
        <div className={styles.imageContainer81}>
          <img 
            src={T66}
            alt="AI Real Estate Lead Management"
            className={styles.mainImage81}
          />
          
        </div>
      </div>

      {/* Right Side - Features */}
      <div className={styles.rightSection81}>
        

        <div className={styles.featuresList81}>
          {/* Feature 1: Instant Response */}
          <div className={styles.featureItem81}>
            <div className={styles.featureIconContainer811}>
              <img 
                src={icon1} 
                alt="Instant Response"
                className={styles.featureIconImage81}
              />
            </div>
            <div className={styles.featureContent81}>
              <h3 className={styles.featureTitle81}>Instant Response</h3>
              <p className={styles.featureDescription81}>
                Never miss a lead again. AI responds to inquiries in seconds, any time of day.
              </p>
            </div>
          </div>

          {/* Feature 2: Smart Qualification */}
          <div className={styles.featureItem81}>
            <div className={styles.featureIconContainer811}>
              <img 
                src={icon2}
                alt="Smart Qualification"
                className={styles.featureIconImage81}
              />
            </div>
            <div className={styles.featureContent81}>
              <h3 className={styles.featureTitle81}>Smart Qualification</h3>
              <p className={styles.featureDescription81}>
                Automatically qualify leads based on budget, location, and preferences.
              </p>
            </div>
          </div>

          {/* Feature 3: Automated Follow-up */}
          <div className={styles.featureItem81}>
            <div className={styles.featureIconContainer811}>
              <img 
                src={icon3}
                alt="Automated Follow-up"
                className={styles.featureIconImage81}
              />
            </div>
            <div className={styles.featureContent81}>
              <h3 className={styles.featureTitle81}>Automated Follow-up</h3>
              <p className={styles.featureDescription81}>
                Keep prospects engaged with personalized follow-ups and property recommendations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>



























{/* What Makes ToxBox AI Different 87 */}
<section className={styles.section87}>
  <div className={styles.container87}>
    {/* Header Section */}
    <div className={styles.headerSection87}>
      <h1 className={styles.title87}>
        What Makes ToxBox AI Different 
        {/* <span className={styles.highlight44}>Retail</span> */}
      </h1>
      {/* <p className={styles.subtitle44}>
        Our AI-powered platform seamlessly integrates with your existing systems to deliver intelligent, automated support that scales with your needs.
      </p>  */}
    </div>
  
    {/* Capabilities Grid */}
    <div className={styles.capabilitiesGrid87}>
      {/* Card 1 */}
      <div className={styles.capabilityCard87}>
        <div className={styles.cardHeader87}>
          <div className={styles.cardIcon87T1}>
            <img 
              src={iconT44}
              alt="Customer Service Icon" 
              className={styles.iconImage87}
            />
          </div>
          <h3 className={styles.cardTitle87}>Speed</h3>
        </div>
        <p className={styles.cardDescription87}>
          Respond to leads in under 3 seconds. Beat competitors who take hours or days to follow up.
        </p>
      </div>

      {/* Card 2 */}
      <div className={styles.capabilityCard87}>
        <div className={styles.cardHeader87}>
          <div className={styles.cardIcon87T2}>
            <img 
              src={iconT45} 
              alt="Customer Service Icon" 
              className={styles.iconImage87}
            />
          </div>
          <h3 className={styles.cardTitle87}>Accuracy</h3>
        </div>
        <p className={styles.cardDescription87}>
          AI understands context and provides accurate property information and answers to complex questions.
        </p>
      </div>

      {/* Card 3 */}
      <div className={styles.capabilityCard87}>
        <div className={styles.cardHeader87}>
          <div className={styles.cardIcon87T3}>
            <img 
              src={iconT46} 
              alt="Customer Service Icon" 
              className={styles.iconImage87}
            />
          </div>
          <h3 className={styles.cardTitle87}>Personalization</h3>
        </div>
        <p className={styles.cardDescription87}>
          Every conversation is tailored to the prospect's specific needs, preferences, and search criteria.
        </p>
      </div>

      

      
    </div>
  </div>
</section>



















{/* What ToxBox AI Delivers 88 */}
<section className={styles.Build88}>
  <div className={styles.container88}>
    {/* Header */}
    <div className={styles.header88}>
      <h2 className={styles.title88}>What ToxBox AI Delivers</h2>
    </div>

    {/* Stats Cards */}
    <div className={styles.cardsGrid88}>
      {/* Card 1: More Qualified Leads */}
      <div className={styles.card88}>
        <div className={styles.cardContent88}>
          <div className={styles.statWrapper88}>
            <div className={styles.statNumber88}>50%+</div>
            <div className={styles.statTitle88}>More Qualified Leads</div>
          </div>
          <p className={styles.statDescription88}>
            Engage every prospect instantly and qualify them automatically based on your criteria.
          </p>
        </div>
        {/* <div className={styles.cardIcon88}>🚀</div> */}
      </div>

      {/* Card 2: Faster Response Time */}
      <div className={styles.card88}>
        <div className={styles.cardContent88}>
          <div className={styles.statWrapper88}>
            <div className={styles.statNumber88}>10x Faster</div>
            <div className={styles.statTitle88}>Response Time</div>
          </div>
          <p className={styles.statDescription88}>
            From hours to seconds. Beat competitors and capture leads while they're hot.
          </p>
        </div>
        {/* <div className={styles.cardIcon88}>⚡</div> */}
      </div>

      {/* Card 3: 24/7 Availability */}
      <div className={styles.card88}>
        <div className={styles.cardContent88}>
          <div className={styles.statWrapper88}>
            <div className={styles.statNumber88}>24/7</div>
            <div className={styles.statTitle88}>Availability</div>
          </div>
          <p className={styles.statDescription88}>
            Never miss an opportunity. AI works around the clock, even when you're sleeping.
          </p>
        </div>
        {/* <div className={styles.cardIcon88}>🕒</div> */}
      </div>
    </div>
  </div>
</section>










{/* Mehboob Automations That Fire Instantly */}
<section className={styles.struct89}>
  <div className={styles.container89}>
    {/* Header Section */}
    <div className={styles.header89}>
      <h2 className={styles.title89}>Mehboob Automations That Fire Instantly</h2>
      <p className={styles.subtitle89}>
        Powerful automation workflows that engage, qualify, and convert leads automatically
      </p>
    </div>

    {/* Cards Section */}
    <div className={styles.cardsContainer89}>
      {/* Card 1: Instant Chat */}
      <div className={styles.cardWrapper89}>
        <div className={styles.card89}>
          <div className={styles.iconContainer89T}>
            <img 
              src={icon4}
              alt="Instant Chat"
              className={styles.icon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>Instant Chat</h3>
        </div>
        <p className={styles.cardDescription89}>
          AI engages visitors the moment they land on your site
        </p>
      </div>

      {/* Card 2: Email Follow-ups */}
      <div className={styles.cardWrapper89}>
        <div className={styles.card89}>
          <div className={styles.iconContainer89T}>
            <img 
              src={icon5} 
              alt="Email Follow-ups"
              className={styles.icon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>Email Follow-ups</h3>
        </div>
        <p className={styles.cardDescription89}>
          Automated personalized email sequences based on behavior
        </p>
      </div>

      {/* Card 3: SMS Alerts */}
      <div className={styles.cardWrapper89}>
        <div className={styles.card89}>
          <div className={styles.iconContainer89T}>
            <img 
              src={icon6} 
              alt="SMS Alerts"
              className={styles.icon89}
            />
          </div>
          <h3 className={styles.cardTitle89}>SMS Alerts</h3>
        </div>
        <p className={styles.cardDescription89}>
          Instant text notifications for hot leads and appointments
        </p>
      </div>
    </div>
  </div>
</section>
























{/* What You Get - No Nonsense */}
<section className={styles.HealthProvider90}>
  <div className={styles.container90}>
    <h2 className={styles.title90}>What You Get - No Nonsense</h2>
    <p className={styles.subtitle90}>Empowering realestate organizations with intelligent automation and AI-driven solutions</p>
    
    <div className={styles.cardsGrid90}>
      {/* Hospital & Clinics Card */}
      <div className={styles.card90}>
        <div className={styles.cardImageContainer90}>
          <img 
            src={T56} 
            alt="Hospital and Clinic AI Solutions"
            className={styles.cardImage90}
          />
        </div>
        <div className={styles.cardContent90}>
          <h3 className={styles.cardTitle90}>Property Matching</h3>
          <p className={styles.cardDescription90}>
            AI matches prospects with perfect properties from your listings.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Intelligent patient scheduling</li>
            <li className={styles.featureItem64}>Automated care coordination</li>
            <li className={styles.featureItem64}>Resource optimization</li>
          </ul> */}
        </div>
      </div>
      
      {/* Telemedicine Platforms Card */}
      <div className={styles.card90}>
        <div className={styles.cardImageContainer90}>
          <img 
            src={T57} 
            alt="Telemedicine AI Solutions"
            className={styles.cardImage90}
          />
        </div>
        <div className={styles.cardContent90}>
          <h3 className={styles.cardTitle90}>Appointment Scheduling</h3>
          <p className={styles.cardDescription90}>
            Automatically book viewings and sync with your calendar.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Virtual consultation assistance</li>
            <li className={styles.featureItem64}>Real-time symptom analysis</li>
            <li className={styles.featureItem64}>Remote monitoring tools</li>
          </ul> */}
        </div>
      </div>
      
      {/* Pharmacies Card */}
      <div className={styles.card90}>
        <div className={styles.cardImageContainer90}>
          <img 
            src={T58} 
            alt="Pharmacy AI Solutions"
            className={styles.cardImage90}
          />
        </div>
        <div className={styles.cardContent90}>
          <h3 className={styles.cardTitle90}>Lead Qualification</h3>
          <p className={styles.cardDescription90}>
            Smart scoring system identifies your best prospects.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Automated refill reminders</li>
            <li className={styles.featureItem64}>Medication interaction alerts</li>
            <li className={styles.featureItem64}>Customer guidance systems</li>
          </ul> */}
        </div>
      </div>
      
      {/* Medical Labs Card */}
      <div className={styles.card90}>
        <div className={styles.cardImageContainer90}>
          <img 
            src={T59} 
            alt="Medical Lab AI Solutions"
            className={styles.cardImage90}
          />
        </div>
        <div className={styles.cardContent90}>
          <h3 className={styles.cardTitle90}>Analytics Dashboard</h3>
          <p className={styles.cardDescription90}>
            Track performance and optimize your conversion funnel.
          </p>
          {/* <ul className={styles.cardFeatures64}>
            <li className={styles.featureItem64}>Smart appointment scheduling</li>
            <li className={styles.featureItem64}>Automated result delivery</li>
            <li className={styles.featureItem64}>Test prioritization</li>
          </ul> */}
        </div>
      </div>
    </div>
  </div>
</section>


















{/* See How a Lead Moves Through ToxBox AI 95 */}
<section className={styles.View95}>
  <div className={styles.container95}>
    {/* Header Section */}
    <div className={styles.header95}>
      <h2 className={styles.title95}>See How a Lead Moves Through ToxBox AI</h2>
    </div>

    {/* Process Steps Grid */}
    <div className={styles.processGrid95}>
      {/* Step 1: Lead Arrives */}
      <div className={styles.processCard95}>
        <div className={styles.stepIcon95}>
          <div className={styles.stepNumber95}>1</div>
        </div>
        <h3 className={styles.stepTitle95}>Lead Arrives</h3>
        <p className={styles.stepDescription95}>Visitor lands on website</p>
      </div>

      {/* Step 2: AI Engages */}
      <div className={styles.processCard95}>
        <div className={styles.stepIcon95}>
          <div className={styles.stepNumber95}>2</div>
        </div>
        <h3 className={styles.stepTitle95}>AI Engages</h3>
        <p className={styles.stepDescription95}>Instant conversation starts</p>
      </div>

      {/* Step 3: Qualify */}
      <div className={styles.processCard95}>
        <div className={styles.stepIcon95}>
          <div className={styles.stepNumber95}>3</div>
        </div>
        <h3 className={styles.stepTitle95}>Qualify</h3>
        <p className={styles.stepDescription95}>Budget & preferences captured</p>
      </div>

      {/* Step 4: Match */}
      <div className={styles.processCard95}>
        <div className={styles.stepIcon95}>
          <div className={styles.stepNumber95}>4</div>
        </div>
        <h3 className={styles.stepTitle95}>Match</h3>
        <p className={styles.stepDescription95}>Perfect properties shown</p>
      </div>

      {/* Step 5: Schedule */}
      <div className={styles.processCard95}>
        <div className={styles.stepIcon95}>
          <div className={styles.stepNumber95}>5</div>
        </div>
        <h3 className={styles.stepTitle95}>Schedule</h3>
        <p className={styles.stepDescription95}>Viewing booked automatically</p>
      </div>

      {/* Step 6: Convert */}
      <div className={styles.processCard95}>
        <div className={styles.stepIcon95}>
          <div className={styles.stepNumber95}>6</div>
        </div>
        <h3 className={styles.stepTitle95}>Convert</h3>
        <p className={styles.stepDescription95}>Lead becomes a client</p>
      </div>
    </div>
  </div>
</section>














{/* Frequently Asked Questions - Construct96 */}
<section className={styles.Construct96}>
  <div className={styles.container96}>
    {/* Header */}
    <div className={styles.header96}>
      <h2 className={styles.title96}>Frequently Asked Questions</h2>
    </div>

    {/* FAQ Items */}
    <div className={styles.faqContainer96}>
      {faqs.map((faq, index) => (
        <div 
          key={index} 
          className={`${styles.faqItem96} ${openIndex === index ? styles.active96 : ''}`}
        >
          <div 
            className={styles.faqQuestion96} 
            onClick={() => toggleFAQ(index)}
          >
            <span className={styles.questionText96}>{faq.question}</span>
            <span className={styles.arrowIcon96}>
              {openIndex === index ? '▲' : '▼'}
            </span>
          </div>
          
          {openIndex === index && (
            <div className={styles.faqAnswer96}>
              <p className={styles.answerText96}>{faq.answer}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</section>






















<section className={styles.Plot97}>
  <div className={styles.container97}>
    <div className={styles.content97}>
      {/* Left Side - Image */} 
      <div className={styles.imageSection97}>
        <img 
          src={bgT56} 
          alt="Lead Management Dashboard"
          className={styles.featureImage97}
        />
      </div>

      {/* Right Side - Content */}
      <div className={styles.textSection97}>
        <h2 className={styles.title97}>
          Ready to Transform <br /> YourLead Management?
        </h2>
        
        <p className={styles.description97}>
          Stop losing leads to slow response times. Start converting more prospects into clients with AI that works 24/7 to engage, qualify, and nurture every opportunity.
        </p>

        {/* CTA Buttons */}
        <div className={styles.buttons97}>
          <button 
            className={`${styles.button97} ${styles.primaryButton97}`}
            onClick={() => handleCTAClick('Start Free Trial')}
          >
            Start Free Trial →
          </button>
          <button 
            className={`${styles.button97} ${styles.secondaryButton97}`}
            onClick={() => handleCTAClick('Schedule Demo')}
          >
            Schedule Demo
          </button>
        </div>

        
      </div>
    </div>
  </div>
</section>








      
    </div>
  );
};

export default RealEstate;